import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=2cc815e4"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc815e4')) {
      api.createRecord('2cc815e4', component.options)
    } else {
      api.reload('2cc815e4', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=2cc815e4", function () {
      api.rerender('2cc815e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Users/UserProfile.vue"
export default component.exports